var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { getBelowDataInfoStyle } from './BelowDataInfoStyle';
import { Avatar, isValidObject, Typography, useBreakpoint } from '@airtel/air-design-system';
import { getTextType } from '../../OrderSummaryCardWidgetStyles';
var BelowDataInfo = props => {
  var subTitleProps = props.subTitleProps,
    style = props.style,
    textImageView = props.textImageView;
  var styles = getBelowDataInfoStyle();
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var textProps = textImageView.textProps,
    avatarProps = textImageView.avatarProps,
    avatarProp = __rest(textImageView, ["textProps", "avatarProps"]);
  return isValidObject(textProps) || isValidObject(avatarProps) || isValidObject(subTitleProps) ? _jsxs(View, Object.assign({
    style: [styles.container, style]
  }, {
    children: [isValidObject(subTitleProps) && _jsx(Typography, Object.assign({
      type: getTextType('subheading', isSmallScreen)
    }, subTitleProps)), _jsxs(View, Object.assign({
      style: [styles.lastViewStyle, avatarProp === null || avatarProp === void 0 ? void 0 : avatarProp.style]
    }, {
      children: [isValidObject(textProps) && _jsx(Typography, Object.assign({}, textProps)), isValidObject(textProps) && _jsx(Avatar, Object.assign({}, avatarProps))]
    }))]
  })) : null;
};
export default BelowDataInfo;